import React, { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import SignIn from "./components/accountManagement/SignIn";
import SignUp from "./components/accountManagement/SignUp";
import ConfirmSignUp from "./components/accountManagement/ConfirmSignUp";
import ConfirmSignIn from "./components/accountManagement/ConfirmSignIn";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import logo from "./images/logo.png";

const initialFormState = {
  username: "",
  password: "",
  email: "",
  confirmationCode: "",
  phone_number: "",
  phone_code: "",
};

let loginUser = "";

function redirectPage() {
  const location = window.location.href.split("/");
  const pathname = location[0] + "/home";
  window.location.replace(pathname);
}

async function signUp(
  { password, email, phone_number },
  updateFormType,
  updateErrMess
) {
  try {
    const username = email;
    if (
      isNaN(phone_number) ||
      (phone_number.length !== 11 && phone_number.length !== 10)
    ) {
      throw new Error("ERR: 電話番号が不正となります。");
    }
    if (phone_number.length === 11 && String(phone_number).indexOf("0") === 0) {
      phone_number = phone_number.substr(1, 10);
    }
    phone_number = "+81" + phone_number;

    await Auth.signUp({
      username,
      password,
      attributes: { email },
      attributes: { phone_number },
    });
    updateFormType("confirmSignUp");
  } catch (err) {
    let strErr = "";
    switch (err.code) {
      case "UsernameExistsException":
        // ユーザープール内に既に同じ username が存在する場合に起こる。
        strErr = "メールアドレスは既に存在します。";
        break;
      case "InvalidPasswordException":
        // ユーザープールのポリシーで設定したパスワードの強度を満たさない場合に起こる。
        strErr =
          "次のパスワードポリシーを満たしません。\n①最小文字数の10文字\n②英大文字・英小文字・数字・記号（^ $ * . [ ] { } ( ) ? - \" ! @ # % & /  , > < ' : ; | _ ~ ` + =）の4種類を含むこと";
        break;
      case "InvalidParameterException":
        // 必要な属性が足りない場合や、入力された各項目が Cognito 側で正しくパースできない場合（バリデーションエラー）に起こる。
        // password が6文字未満の場合はバリデーションエラーでこちらのエラーコードが返ってくる。
        strErr = "ユーザー登録が未認証となります。";
        break;
      default:
        // その他のエラー
        if (String(err.message).indexOf("ERR") > -1)
          strErr = String(err.message).replace("ERR: ", "");
        else strErr = "新規登録失敗しました。";
    }
    updateErrMess(strErr);
  }
}

async function confirmSignUp(
  { email, confirmationCode },
  updateFormType,
  updateErrMess
) {
  try {
    const username = email;
    await Auth.confirmSignUp(username, confirmationCode);
    updateFormType("signIn");
  } catch (err) {
    let strErr = "";
    switch (err.code) {
      case "CodeMismatchException":
        // 無効なコードが入力された場合に起こる。
        strErr = "コードが無効となります。";
        break;
      case "LimitExceededException":
        // コードを間違え続けた場合に起こる。
        strErr = "認証失敗の回数が上限を超えているため、新規登録ができません。";
        break;
      case "ExpiredCodeException":
        // コードが期限切れ（24時間をオーバー）した場合に起こる。
        // 注) username が存在しない・無効化されている場合にも起こる。
        strErr = "コードの有効期限が切れています。";
        break;
      case "NotAuthorizedException":
        // 既にステータスが CONFIRMED になっている場合に起こる。
        strErr = "ユーザー登録が未認証となります。";
        break;
      case "CodeDeliveryFailureException":
        // 検証コードの送信に失敗した場合に起こる。
        strErr = "コードの送信に失敗しました。";
        break;
      default:
        // その他のエラー
        strErr = "認証失敗しました。";
    }

    updateErrMess(strErr);
  }
}

async function confirmSignIn(
  { email, confirmationCode },
  setUser,
  setCognitoUser,
  updateErrMess
) {
  try {
    const user = await Auth.confirmSignIn(
      loginUser,
      confirmationCode,
      "SMS_MFA"
    );
    const userInfo = { username: user.username, ...user.attributes };
    setUser(userInfo);
    setCognitoUser(user);
    redirectPage();
  } catch (err) {
    let strErr = "";
    switch (err.code) {
      case "CodeMismatchException":
        // 無効なコードが入力された場合に起こる。
        strErr = "コードが無効となります。";
        break;
      case "LimitExceededException":
        // コードを間違え続けた場合に起こる。
        strErr = "認証失敗の回数が上限を超えているため、新規登録ができません。";
        break;
      case "ExpiredCodeException":
        // コードが期限切れ（24時間をオーバー）した場合に起こる。
        // 注) username が存在しない・無効化されている場合にも起こる。
        strErr = "コードの有効期限が切れています。";
        break;
      case "NotAuthorizedException":
        // 既にステータスが CONFIRMED になっている場合に起こる。
        strErr = "ユーザー登録が未認証となります。";
        break;
      case "CodeDeliveryFailureException":
        // 検証コードの送信に失敗した場合に起こる。
        strErr = "コードの送信に失敗しました。";
        break;
      default:
        // その他のエラー
        strErr = "認証失敗しました。";
    }
    updateErrMess(strErr);
  }
}

async function signIn({ email, password }, updateFormType, updateErrMess) {
  try {
    const username = email;
    loginUser = await Auth.signIn(username, password);
    updateFormType("confirmSignIn");
  } catch (err) {
    let strErr = "";
    switch (err.code) {
      case "UserNotConfirmedException": {
        // ユーザのステータスが UNCONFIRMED の場合に起こる。
        // SignUp用のコードを再送し、ステータスを CONFIRMED にする必要がある。
        // 検証コードの再送は １．３節の ResendConfirmationCode() を参照。
        strErr = "ユーザー登録が未認証となります。";
        break;
      }
      case "PasswordResetRequiredException": {
        // Cognito コンソールでパスワードをリセット（ユーザープールにユーザをインポートする場合も含む）した場合に起こる。
        // パスワードをリセットする必要がある。
        // パスワードのリセットは 3.1節の SendForgotPasswordCode() 参照。
        strErr = "パスワードをリセットする必要があります。";
        break;
      }
      case "NotAuthorizedException": {
        // 誤ったパスワードを入力した場合に起こる。
        // 注) パスワードを間違え続けた場合にも起こり、 error.message が 'Password attempts exceeded' になる。
        // （エラーコードとして LimitExceededException が返ってくると思ったらそうではなかった）
        strErr = "メールアドレス又はパスワードが不正となります。";
        break;
      }
      case "UserNotFoundException": {
        // PASSWORD_VERIFIER は通るものの username が Cognito ユーザープールに存在しない場合に起こる。
        strErr = "ユーザーが存在しません。";
        break;
      }
      case "InvalidParameterException": {
        // 入力された username や password が Cognito 側で正しくパースできないとき（バリデーションエラー）に起こる。
        // 注) 2019/04/24 現在、Cognito コンソールでパスワードをリセットした場合は 'PasswordResetRequiredException' ではなくこのエラーコードが返される。
        strErr = "メールアドレス又はパスワードが未入力となります。";
        break;
      }
      default:
        // その他のエラー
        strErr = "ログイン失敗しました。";
    }
    updateErrMess(strErr);
  }
}

function Form(props) {
  const [formType, updateFormType] = useState("signIn");
  const [formState, updateFormState] = useState(initialFormState);
  const [errMess, updateErrMess] = useState("");
  function updateForm(event) {
    const newFormState = {
      ...formState,
      ...errMess,
      [event.target.name]: event.target.value,
    };
    updateFormState(newFormState);
  }

  useEffect(() => {
    renderForm();
  }, [errMess]);
  useEffect(() => {
    updateErrMess("");
  }, [formType]);

  function renderForm() {
    switch (formType) {
      case "signUp":
        return (
          <SignUp
            signUp={() => signUp(formState, updateFormType, updateErrMess)}
            updateFormState={(e) => updateForm(e)}
            updateFormType={(e) => updateFormType(e)}
            errMess={errMess}
          />
        );
      case "confirmSignUp":
        return (
          <ConfirmSignUp
            confirmSignUp={() =>
              confirmSignUp(formState, updateFormType, updateErrMess)
            }
            updateFormState={(e) => updateForm(e)}
            errMess={errMess}
          />
        );
      case "signIn":
        return (
          <SignIn
            signIn={() => signIn(formState, updateFormType, updateErrMess)}
            updateFormState={(e) => updateForm(e)}
            updateFormType={(e) => updateFormType(e)}
            updateErrMess={(e) => updateErrMess(e)}
            errMess={errMess}
          />
        );
      case "confirmSignIn":
        return (
          <ConfirmSignIn
            confirmSignIn={() =>
              confirmSignIn(
                formState,
                props.setUser,
                props.setCognitoUser,
                updateErrMess
              )
            }
            updateFormState={(e) => updateForm(e)}
            updateFormType={(e) => updateFormType(e)}
            errMess={errMess}
          />
        );
      default:
        return null;
    }
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          textAlign: "center",
          backgroundColor: "#303234",
          flexGrow: 1,
          height: "80px",
          position: "sticky",
          top: "0",
          zIndex: "5",
        }}
      >
        <Grid container alignItems="center" minWidth="1200px">
          <img
            alt="ロゴ"
            src={logo}
            style={{
              height: "25px",
              marginRight: "16px",
              marginTop: "8px",
              backgroundColor: "transparent",
              marginLeft: "16px",
            }}
          />
        </Grid>
      </Box>
      <Divider
        style={{
          backgroundColor: "white",
          minWidth: "1200px",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "30%",
          bottom: "50%",
          left: 0,
          right: 0,
          margin: "auto",
          minWidth: "1200px",
        }}
      >
        {renderForm()}
      </div>
    </>
  );
}

const styles = {
  signInContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "480px",
    height: "350px",
    margin: "0 auto",
    borderColor: "#BBBCBC",
    borderRadius: "10px",
    boxShadow: "0 0.1rem 0.2rem 0 rgba(83,86,90,.5)",
    backgroundColor: "white",
  },
  signUpContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "480px",
    height: "480px",
    margin: "0 auto",
    borderColor: "#BBBCBC",
    borderRadius: "10px",
    boxShadow: "0 0.1rem 0.2rem 0 rgba(83,86,90,.5)",
    backgroundColor: "white",
  },
  input: {
    height: "40px",
    marginTop: 8,
    width: "400px",
    maxWidth: "400px",
    padding: "0px 8px",
    fontSize: 16,
    outline: "none",
    borderRadius: "5px",
    borderWidth: "1px",
    borderColor: "#BBBCBC",
    borderBottom: "2px solid rgba(0, 0, 0, .3)",
    marginLeft: "auto",
    marginRight: "auto",
  },
  toggleForm: {
    fontWeight: "600",
    padding: "0px 25px",
    marginTop: "15px",
    marginLeft: "16px",
    marginBottom: 0,
    textAlign: "left",
    color: "rgba(0, 0, 0, 0.6)",
  },
  resetPassword: {
    marginTop: "5px",
  },
  anchor: {
    color: "#006bfc",
    cursor: "pointer",
  },
  label: {
    marginLeft: "40px",
    marginTop: "8px",
  },
  errorLabel: {
    marginLeft: "40px",
    marginTop: "8px",
    color: "red",
    whiteSpace: "pre-wrap",
    marginRight: "40px",
  },
};

export { styles, Form as default };
